import React, { useEffect, useRef, useState } from 'react'
import { Button } from '@mui/material';
import useAuth from '../../../../components/hooks/useAuth';
import { useTheme } from '../../../../components/hooks/useTheme';
import { getAboutUs, put_AboutUs } from '../../../../services/aboutUs';
import colorConfigs from '../../../../configs/colorConfigs';
import PleaseWaitPopup from '../../../PleaseWaitPopup';
import ReactQuill from 'react-quill';
import axios from 'axios';
import baseURL from '../../../../configs/api';
import Cookies from 'js-cookie';
import useTenant from '../../../../components/hooks/useTenant';

export const AboutUs = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const modules = {
        toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
            ["link", "image", "video"],
            ["clean"],
        ],
    };

    const { auth }: any = useAuth();
    const { themeStyles, theme } = useTheme();
    const { handleTenantError }: any = useTenant();
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [id, setId] = useState<number>(0);

    const [aboutUs, setAboutUs] = useState<string>('');
    const [aboutUsImage, setAboutUsImage] = useState<string>('');

    const [ourMission, setOurMission] = useState<string>('');
    const [ourMissionImage, setOurMissionImage] = useState<string>('');

    const [ourVision, setOurVision] = useState<string>('');
    const [ourVisionImage, setOurVisionImage] = useState<string>('');

    const [fleetSelection, setFleetSelection] = useState<string>('');
    const [roadsideAssistance, setRoadsideAssistance] = useState<string>('');
    const [insurance, setInsurance] = useState<string>('');

    const [disabled, setDisabled] = useState<boolean>(true);

    const inputFileRef = useRef<HTMLInputElement>(null);
    const missionFileRef = useRef<HTMLInputElement>(null);
    const visionFileRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setPleaseWaitPopup(true);
        getAboutUs(tenantId)
            .then(data => {
                const item = data[0];
                setId(item.id);
                setAboutUs(item.aboutUs || '');
                setAboutUsImage(item.aboutUsImage || '');
                setOurMission(item.ourMission || '');
                setOurMissionImage(item.ourMissionImage || '');
                setOurVision(item.ourVision || '');
                setOurVisionImage(item.ourVisionImage || '');
                setFleetSelection(item.fleetSelection || '');
                setRoadsideAssistance(item.roadsideAssistance || '');
                setInsurance(item.insurance || '');
                setPleaseWaitPopup(false);
                handleTenantError(null);
            })
            .catch(error => {
                setPleaseWaitPopup(false);
                handleTenantError(error);              
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>, setImage: Function) => {
        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const imagePath = `${baseURL}commonFile/Get?name=${response.data}`;
                    setImage(imagePath);
                    setPleaseWaitPopup(false);

                    if (inputFileRef.current) {
                        inputFileRef.current.value = "";
                    }
                    handleTenantError(null);
                })
                .catch((error) => {                  
                    handleTenantError(error);
                    if (inputFileRef.current) {
                        inputFileRef.current.value = "";
                    }
                    setPleaseWaitPopup(false);
                });
        } else {
            setPleaseWaitPopup(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        await put_AboutUs({
            id,
            aboutUs,
            aboutUsImage,
            ourMission,
            ourMissionImage,
            ourVision,
            ourVisionImage,
            fleetSelection,
            roadsideAssistance,
            insurance,
        }, auth?.id, tenantId)
            .then(() => {
                setPleaseWaitPopup(false);
                handleTenantError(null);
            })
            .catch(error => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    };

    const handleEdit = () => {
        setDisabled(false);
    };

    const renderSection = (
        label: string,
        content: string,
        setContent: Function,
        image: string,
        setImage: Function,
        fileRef: React.RefObject<HTMLInputElement>
    ) => (
        <div className="w-full border rounded-md p-4 mb-6">
            <label className={`text-sm font-semibold ${themeStyles.main.textHeadingColor}`}>{label}</label>
            <div className="flex flex-col md:flex-row gap-4 mt-3">
                <div className="w-full md:w-1/3 flex flex-col items-center justify-center min-h-[220px]">
                    {!image && (
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: colorConfigs.btn.main.bg,
                                textTransform: "none",
                                fontSize: "0.75rem",
                                padding: "6px 16px",
                            }}
                            onClick={() => {
                                if (fileRef.current) {
                                    fileRef.current.value = ""
                                }
                                fileRef.current?.click()
                            }}
                            disabled={disabled}
                        >
                            Add Image
                        </Button>
                    )}

                    {image && (
                        <>
                            <img
                                src={image}
                                width={500}
                                height={500}
                                alt="sectionImage"
                                className="mt-2 rounded shadow-md"
                            />

                            <div className="mt-2">
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: colorConfigs.btn.delete.bg,
                                        textTransform: "none",
                                        fontSize: "0.75rem",
                                        padding: "4px 12px",
                                        cursor: disabled ? "not-allowed" : "pointer",
                                    }}
                                    onClick={() => {
                                        if (!disabled) {
                                            setImage("");
                                        }
                                    }}
                                >
                                    Delete
                                </Button>
                            </div>
                        </>
                    )}

                    <input
                        type="file"
                        accept="image/*"
                        ref={fileRef}
                        disabled={disabled}
                        onChange={(e) => handleImageUpload(e, setImage)}
                        style={{ display: "none" }}
                    />
                </div>

                <div className="w-full md:w-2/3">
                    <div className="quill-wrapper relative h-[250px] overflow-hidden border rounded"
                        style={{
                            ...(theme === 'dark' && {
                                '--quill-text-color': '#ffffff',
                                '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                            }),
                        } as React.CSSProperties}
                    >
                        <ReactQuill
                            className="custom-quill-editor"
                            theme="snow"
                            modules={modules}
                            value={content}
                            onChange={(value) => setContent(value)}
                            readOnly={disabled}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className={`p-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
            <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[1px] flex flex-col`}>
                <div className="flex justify-between items-center p-2 border-b">
                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>About Us</h2>
                    {disabled && (
                        <button
                            className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={handleEdit}
                        >
                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>edit</span>
                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                        </button>
                    )}
                </div>
                <form className="w-full p-4" onSubmit={handleSubmit}>
                    {renderSection("About Us", aboutUs, setAboutUs, aboutUsImage, setAboutUsImage, inputFileRef)}
                    {renderSection("Our Mission", ourMission, setOurMission, ourMissionImage, setOurMissionImage, missionFileRef)}
                    {renderSection("Our Vision", ourVision, setOurVision, ourVisionImage, setOurVisionImage, visionFileRef)}

                    <div className="w-full border rounded-md p-4 mb-6">
                        <label className={`text-sm font-semibold ${themeStyles.main.textHeadingColor}`}>Additional Info</label>
                        <div className="flex flex-col gap-4 mt-3">
                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fleet Selection</label>
                                <input
                                    type="text"
                                    value={fleetSelection}
                                    onChange={(e) => setFleetSelection(e.target.value)}
                                    disabled={disabled}
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                />
                            </div>
                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Roadside Assistance</label>
                                <input
                                    type="text"
                                    value={roadsideAssistance}
                                    onChange={(e) => setRoadsideAssistance(e.target.value)}
                                    disabled={disabled}
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                />
                            </div>
                            <div>
                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Insurance</label>
                                <input
                                    type="text"
                                    value={insurance}
                                    onChange={(e) => setInsurance(e.target.value)}
                                    disabled={disabled}
                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                />
                            </div>
                        </div>
                    </div>
                    {!disabled && (
                        <Button
                            variant="contained"
                            sx={{ backgroundColor: colorConfigs.btn.main.bg }}
                            type="submit"
                        >
                            Save
                        </Button>
                    )}
                </form>
            </div>
            <style>
                {`
  .custom-quill-editor .ql-editor {
    height: 180px;
    overflow-y: auto;
     background-color: #ffffff;
  color: #000000;
  }

  .custom-quill-editor .ql-toolbar {
  background-color: #f9f9f9;
  border-color: #ccc;
}
`}
            </style>
            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </div>
    );
};
